  import { defineComponent, type PropType } from "vue";
  import AttestationDateDemande from '@/extend/controls/attestation/AttestationDateDemande';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import AttestationDateValid from '@/extend/controls/attestation/AttestationDateValid';
  import AttestationDefSelect from '@/extend/controls/attestationDef/AttestationDefSelect';
  import AttestationMotif from '@/extend/controls/attestation/AttestationMotif';
  import AttestationStatut from '@/extend/controls/attestation/AttestationStatut';
  import EtablissementSelect from '@/extend/controls/etablissement/EtablissementSelect';
  import Attestation from '@/extend/classes/Attestation';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeAttestation } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      AttestationDateDemande,
      AttestationDateValid,
      AttestationDefSelect,
      AttestationMotif,
      AttestationStatut,
      EtablissementSelect,
    },

    props: {
      attestation: {
        type: Object as PropType<Attestation>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetAttestationDefSelect: {
        type: Boolean
      },
      toggleResetEtablissementSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        dateDemandeStatus: new FieldStatus(false, false, 0),
        strDateDemande: '',
        dateValidStatus: new FieldStatus(false, false, 0),
        strDateValid: '',
    toggleAttestationDefId: false,
        attestationDefIdStatus: new FieldStatus(false, false, 0),
        strAttestationDefId: '',
        motifStatus: new FieldStatus(false, false, 0),
        strMotif: '',
        statutStatus: new FieldStatus(false, false, 0),
        strStatut: '',
    toggleEtablissementId: false,
        etablissementIdStatus: new FieldStatus(false, false, 0),
        strEtablissementId: '',
        refAttestation: new Attestation,
        cloneAttestation: new Attestation,
      attestationSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.ATTESTATION,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editAttestation.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editAttestation: {
        get(): Attestation {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.attestation != undefined) {
              if (this.attestation.id == 0) {
                Alerts.debug('CrudAttestation : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneAttestation.id != this.attestation.id && !this.saving) {
                this.handleAttestationChange();
              }
            }
          }
          return this.refAttestation;
        },
        set(value: Attestation) {
          this.refAttestation = value;
        }
      },

      canCreate (): boolean {
        return this.refAttestation.id > 0;
      },

      canDelete (): boolean {
        return this.refAttestation.canDelete && this.refAttestation.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      dateDemande: {
        get(): Date | null {
          return this.editAttestation.dateDemande;
        },
        set(value: Date | null) {
          this.editAttestation.dateDemande = value;
          this.fieldUpdated('DATE_DEMANDE', value);
        }
      },

      periodDateDemande() : Period[] {
        return []
      },

      dateValid: {
        get(): Date | null {
          return this.editAttestation.dateValid;
        },
        set(value: Date | null) {
          this.editAttestation.dateValid = value;
          this.fieldUpdated('DATE_VALID', value);
        }
      },

      periodDateValid() : Period[] {
        return []
      },
    resetAttestationDefId (): boolean {
      return this.toggleAttestationDefId
    },

      attestationDefId: {
        get(): number {
          return this.editAttestation.attestationDefId;
        },
        set(value: number) {
          this.editAttestation.attestationDefId = value;
          this.fieldUpdated('ATTESTATION_DEF_ID', value);
        }
      },


      motif: {
        get(): string {
          return this.editAttestation.motif;
        },
        set(value: string) {
          this.editAttestation.motif = value;
          this.fieldUpdated('MOTIF', value);
        }
      },


      statut: {
        get(): number {
          return this.editAttestation.statut;
        },
        set(value: number) {
          this.editAttestation.statut = value;
          this.fieldUpdated('STATUT', value);
        }
      },

    resetEtablissementId (): boolean {
      return this.toggleEtablissementId
    },

      etablissementId: {
        get(): number {
          return this.editAttestation.etablissementId;
        },
        set(value: number) {
          this.editAttestation.etablissementId = value;
          this.fieldUpdated('ETABLISSEMENT_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.attestation.canUpdate && (
        (this.isDisplayed('DATE_DEMANDE') && !this.readOnly('DATE_DEMANDE')) ||
        (this.isDisplayed('DATE_VALID') && !this.readOnly('DATE_VALID')) ||
        (this.isDisplayed('ATTESTATION_DEF_ID') && !this.readOnly('ATTESTATION_DEF_ID')) ||
        (this.isDisplayed('MOTIF') && !this.readOnly('MOTIF')) ||
        (this.isDisplayed('STATUT') && !this.readOnly('STATUT')) ||
        (this.isDisplayed('ETABLISSEMENT_ID') && !this.readOnly('ETABLISSEMENT_ID')));
        return !res;
      },

      fields (): string[] {
        return ['DATE_DEMANDE', 'DATE_VALID', 'ATTESTATION_DEF_ID', 'MOTIF', 'STATUT', 'ETABLISSEMENT_ID'];
      },
    },

    methods: {
      handleAttestationChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.attestation);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.attestation);
          }
        } else if (!this.inDialog) {
          if (this.cloneAttestation.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.attestation);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.dateDemandeStatus != undefined && this.dateDemandeStatus.updated) ||
          (this.dateValidStatus != undefined && this.dateValidStatus.updated) ||
          (this.attestationDefIdStatus != undefined && this.attestationDefIdStatus.updated) ||
          (this.motifStatus != undefined && this.motifStatus.updated) ||
          (this.statutStatus != undefined && this.statutStatus.updated) ||
          (this.etablissementIdStatus != undefined && this.etablissementIdStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.attestation);
        }
      },

      setError (): void {
        const error = this.dateDemandeStatus.error ||
        this.dateValidStatus.error ||
        this.attestationDefIdStatus.error ||
        this.motifStatus.error ||
        this.statutStatus.error ||
        this.etablissementIdStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.attestation);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refAttestation.id < 0) {
          storeAttestation.mAttestationDeleted(this.refAttestation.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refAttestation.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveAttestation()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.attestationSaving = false;
          this.createRef(this.refAttestation);
          this.$emit('updated', this.refAttestation);
          if (this.attestation.id > 0) {
            this.$emit('saved', this.refAttestation);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refAttestation.failed) {
          this.saveLoading = false;
            this.attestationSaving = false;
            this.refAttestation.failed = false;
          }
        }
      },

      saveAttestation (): boolean {
        if (!this.refAttestation.compareAttestation(this.cloneAttestation)) {
          if (!this.attestationSaving) {
            this.attestationSaving = true;
          if (this.refAttestation.id > 0) {
            storeAttestation.updateAttestation(this.refAttestation)
              .then((data: Attestation) => {
                if (!data.failed) {
                  this.refAttestation = storeAttestation.getAttestation(data.id);
                  this.cloneAttestation = data.cloneAttestation();
                } else {
                  this.refAttestation.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.attestationSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refAttestation.id <= 0) {
              storeAttestation.createAttestation(this.refAttestation)
                .then((data: Attestation) => {
                  if (!data.failed) {
                    this.refAttestation = storeAttestation.getAttestation(data.id);
                    this.cloneAttestation = data.cloneAttestation();
                  } else {
                this.refAttestation.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.attestationSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refAttestation.id <= 0) {
          storeAttestation.mAttestationDeleted(this.refAttestation.id);
        } else {
          storeAttestation.deleteAttestation(this.refAttestation);
        }
      },

      statusDateDemande (value: FieldStatus): void {
        this.dateDemandeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateValid (value: FieldStatus): void {
        this.dateValidStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAttestationDefId (value: FieldStatus): void {
        this.attestationDefIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusMotif (value: FieldStatus): void {
        this.motifStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusStatut (value: FieldStatus): void {
        this.statutStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusEtablissementId (value: FieldStatus): void {
        this.etablissementIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteAttestation(): void {
        this.$emit('deleteAttestation',  this.attestation);
      },

    addAttestation(): void {
      this.$emit('addAttestation',  this.attestation);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneAttestation != undefined) {
          this.restoring = true;
          this.refAttestation.dateDemande = this.cloneAttestation.dateDemande;
          this.refAttestation.dateValid = this.cloneAttestation.dateValid;
          this.refAttestation.attestationDefId = this.cloneAttestation.attestationDefId;
          this.refAttestation.motif = this.cloneAttestation.motif;
          this.refAttestation.statut = this.cloneAttestation.statut;
          this.refAttestation.etablissementId = this.cloneAttestation.etablissementId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Attestation): void {
        this.clearRef();
        this.editAttestation = value;
        this.cloneAttestation = value.cloneAttestation();
        this.dateDemandeStatus.clear(value.id);
        this.dateValidStatus.clear(value.id);
        this.attestationDefIdStatus.clear(value.id);
        this.motifStatus.clear(value.id);
        this.statutStatus.clear(value.id);
        this.etablissementIdStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_DEMANDE') && this.$refs.DATE_DEMANDE) this.$refs.DATE_DEMANDE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_VALID') && this.$refs.DATE_VALID) this.$refs.DATE_VALID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ATTESTATION_DEF_ID') && this.$refs.ATTESTATION_DEF_ID) this.$refs.ATTESTATION_DEF_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MOTIF') && this.$refs.MOTIF) this.$refs.MOTIF.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('STATUT') && this.$refs.STATUT) this.$refs.STATUT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID) this.$refs.ETABLISSEMENT_ID.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_DEMANDE') && this.isDisplayed('DATE_DEMANDE') && this.$refs.DATE_DEMANDE && this.$refs.DATE_DEMANDE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_VALID') && this.isDisplayed('DATE_VALID') && this.$refs.DATE_VALID && this.$refs.DATE_VALID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ATTESTATION_DEF_ID') && this.isDisplayed('ATTESTATION_DEF_ID') && this.$refs.ATTESTATION_DEF_ID && this.$refs.ATTESTATION_DEF_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MOTIF') && this.isDisplayed('MOTIF') && this.$refs.MOTIF && this.$refs.MOTIF.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'STATUT') && this.isDisplayed('STATUT') && this.$refs.STATUT && this.$refs.STATUT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ETABLISSEMENT_ID') && this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID && this.$refs.ETABLISSEMENT_ID.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_DEMANDE') && this.$refs.DATE_DEMANDE) this.$refs.DATE_DEMANDE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_VALID') && this.$refs.DATE_VALID) this.$refs.DATE_VALID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ATTESTATION_DEF_ID') && this.$refs.ATTESTATION_DEF_ID) this.$refs.ATTESTATION_DEF_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MOTIF') && this.$refs.MOTIF) this.$refs.MOTIF.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('STATUT') && this.$refs.STATUT) this.$refs.STATUT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID) this.$refs.ETABLISSEMENT_ID.save();
      },

      getValue (field: string): string {
         if (field == 'DATE_DEMANDE') return this.dateDemande == null ? '' : this.dateDemande.toString();
        else  if (field == 'DATE_VALID') return this.dateValid == null ? '' : this.dateValid.toString();
        else  if (field == 'ATTESTATION_DEF_ID') return this.attestationDefId.toString();
        else  if (field == 'MOTIF') return this.motif.toString();
        else  if (field == 'STATUT') return this.statut.toString();
        else  if (field == 'ETABLISSEMENT_ID') return this.etablissementId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
